import fetch from 'isomorphic-fetch';
import {
	API2_URL, VERSION_EDIT, VERSIONS_REQUEST, VERSIONS_SHOW, VERSIONS_FAIL, VERSION_CLEAR, VERSIONS_LIST
} from "../store/config";
import { newNotification } from "./notifications";
import { history } from "../store/store";
import _ from "lodash";
import { sessionService } from 'redux-react-session';

export const fetchVersionsShow = (page = 1) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				dispatch(versionsRequest());
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				return fetch(`${API2_URL}/versions?page=${page}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(versionsData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionsFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

export const versionsList = () => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'get'
				};

				dispatch(versionsRequest());
				return fetch(`${API2_URL}/versions?per_page=all`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => dispatch(versionsListData(json)),
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionsFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Section VERSION_EDIT*/
export const fetchVersion = (year) => (dispatch) =>{
	return dispatch(sessionService.loadUser)
		.then(sess => {
			dispatch(versionsRequest());
			dispatch(versionClear());

			const options = {headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
					'Authorization': `Bearer ${sess.profile.access_token}`
				},
				method: 'get'
			};

			return fetch(`${API2_URL}/versions/${year}?include[0]=phases_groups.version_phase_group`, options)
				.then(result => {
					if (result.status >= 200 && result.status < 300) {
						return result.json();
					} else {
						return result.json().then(Promise.reject.bind(Promise));
					}
				})
				.then(
					json => dispatch(versionEditData(json)),
					error => {
						dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
						return dispatch(versionsFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
					}
				);
		})
}

/*Section VERSION_SAVE*/
export const versionSave = (values) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'post',
					body: JSON.stringify(values)
				};

				dispatch(versionsRequest());

				return fetch(`${API2_URL}/versions${values.id ? `/${values.year}?include[0]=phases_groups.version_phase_group&_method=PUT`:'?include[0]=phases_groups.version_phase_group'}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: "La version se ha guardado correctamente", type: "success"}));
							if(_.isEmpty(values.id)){
								history.push(`/versiones/editar/${json.data.year}`);
							}
							return dispatch(versionEditData(json));
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionsFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

/*Section VERSION_DELETE*/
export const versionDelete = (year) => {
	return dispatch => {
		return dispatch(sessionService.loadUser)
			.then(sess => {
				const options = {headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json',
						'Authorization': `Bearer ${sess.profile.access_token}`
					},
					method: 'delete'
				};

				dispatch(versionsRequest());

				return fetch(`${API2_URL}/versions/${year}`, options)
					.then(result => {
						if (result.status >= 200 && result.status < 300) {
							return result.json();
						} else {
							return result.json().then(Promise.reject.bind(Promise));
						}
					})
					.then(
						json => {
							dispatch(newNotification({title: "Éxito", content: "Versión eliminada correctamente", type: "success"}));
							dispatch(fetchVersionsShow());
						},
						error => {
							dispatch(newNotification({title:"¡Oh no!", content: error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error), type: "danger"}));
							return dispatch(versionsFailed(error.message ? (error.errors ? `${error.message} - ${_.values(error.errors)}`:error.message):_.values(error)));
						}
					);
			})
	}
}

const versionsRequest = () => {
	return {
		type: VERSIONS_REQUEST,
		isFetching: true,
		timestamp: Date.now()
	}
}

const versionsData = (json) => {
	return {
		type: VERSIONS_SHOW,
		isFetching: false,
		payload: json.data,
		pages: {
			current: json.current_page,
			per_page: json.per_page,
			total: json.total
		},
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const versionsListData = (json) => {
	return {
		type: VERSIONS_LIST,
		isFetching: false,
		payload: json.data,
		timestamp: Date.now()
	}
}

const versionEditData = (json) => {
	let phases_groups = []; let response = json.data;

	_.mapKeys(json.data.phases_groups, (item) => {
		return phases_groups.push({id: item.id, name: item.name, start_date: item.version_phase_group.start_date, end_date: item.version_phase_group.end_date, version_phase_group: item.version_phase_group});
	})

	response.phases_groups = _.orderBy(phases_groups, ['id'])

	return {
		type: VERSION_EDIT,
		isFetching: false,
		payload: response,
		permissions: json.permissions,
		timestamp: Date.now()
	}
}

const versionClear = () => {
	return {
		type: VERSION_CLEAR,
		payload: {
			phases_groups:[]
		},
		timestamp: Date.now()
	}
}

const versionsFailed = (error) => {
	return {
		type: VERSIONS_FAIL,
		isFetching: false,
		error: error,
		timestamp: Date.now()
	}
}




// WEBPACK FOOTER //
// ./src/actions/versions.js